
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface JoinSectionProps {}

const JoinSection = ({}: JoinSectionProps) => {
  return (
    <section className="px-4 py-16 bg-gradient-to-r from-corporate-primary-100 to-corporate-primary-75 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('/lovable-uploads/8fd12166-0122-42a4-9da3-b430e2991c7a.png')] bg-center bg-no-repeat opacity-10"></div>
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="text-3xl font-bold mb-3">Join Us Today</h2>
        <div className="w-24 h-1 bg-corporate-secondary-100 mx-auto mb-6"></div>
        <p className="text-xl mb-8 opacity-90 max-w-2xl mx-auto">
          Discover how METRADE can make your crypto journey both profitable and enjoyable.
        </p>
        <Link to="/signup">
          <Button 
            size="lg" 
            className="bg-corporate-secondary-100 text-corporate-neutral-100 hover:bg-corporate-secondary-75 transform hover:scale-105 transition-all duration-300 px-8 py-6 text-lg font-medium"
          >
            Get Started
          </Button>
        </Link>
      </div>
      
      <div className="absolute bottom-0 left-0 w-40 h-40 bg-corporate-secondary-100 rounded-full filter blur-3xl opacity-20 -mb-20 -ml-20"></div>
      <div className="absolute top-0 right-0 w-64 h-64 bg-corporate-secondary-75 rounded-full filter blur-3xl opacity-20 -mt-32 -mr-32"></div>
    </section>
  );
};

export default JoinSection;
